import { routes } from '@/constants/routes'

export const AUTH_ROUTES: readonly string[] = [
  routes.login,
  routes.forgotPassword,
  routes.resetPassword,
  routes.updatePassword,
] as const

export const AUTH_OPEN_ROUTES: readonly string[] = [
  routes.account,
  routes.healthCheck,
  routes.generatedChromium,
  routes.mcpLogin,
] as const

export const COGNITO_COOKIE_PREFIX = 'CognitoIdentityServiceProvider.'

/**
 * Cookie name prefixes that identify auth state. Used by every code path that
 * needs to wipe the local session (proxy `clearAuthCookies`, sign-out Route
 * Handler, and `logoutAction`). Keep the list here so the two cookie-clearing
 * surfaces (NextResponse vs `cookies()` API) can't drift.
 */
export const AUTH_COOKIE_PREFIXES: readonly string[] = [
  COGNITO_COOKIE_PREFIX,
  'amplify-config-',
] as const
